import { LoaderIcon } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';

import { NegativePlaceholder } from '../../shared/components/NegativePlaceholder';
import type { AlertsManagerWidgetState } from '../AlertsManagerWidgetState';

import { ViewResolver } from './ViewResolver';

type AnalysisWidgetProp = {
  widgetState: AlertsManagerWidgetState;
  externalContainer?: Element;
};

export const AlertsManagerWidget = observer(({ widgetState }: AnalysisWidgetProp) => {
  const themeClassName = widgetState.appParams.theme === 'dark' ? 'go-widget-theme-dark' : 'go-widget-theme-light';

  if (widgetState.status === 'failed') {
    return <NegativePlaceholder className={themeClassName} message={widgetState.cause ?? ''} />;
  }

  if (widgetState.status !== 'ready' || widgetState.viewStore == null) {
    return <LoaderIcon />;
  }

  return <ViewResolver viewStore={widgetState.viewStore} widgetState={widgetState} />;
});
